export const buildNavLinkUrl = (slug: string, language: string, currency?: string) => {
    // Country code urls are not used anymore
    // return `/${language}/products/${slug}`;
    return `/products/${slug}${currency ? `?currency=${currency}` : ''}`;
};



// WEBPACK FOOTER //
// ./src/helpers/categories/buildNavLinkUrl.ts